module.exports = __webpack_public_path__ + "static/media/decryptor.1f65a407.jpeg";